import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Components/Login/Login";
import Home from "./Components/Home/Home";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import GitFlowReleaseManagement from "./Components/GitFlowReleaseManagement/GitFlowReleaseManagement";
import GitFlowHotfixManagement from "./Components/GitFlowHotfixManagement/GitFlowHotfixManagement";
import TBDReleaseManagement from "./Components/TBDReleaseManagement/TBDReleaseManagement";
import OpenedReleasesHotfixes from "./Components/GitFlowReleaseManagement/OpenedReleasesHotfixes";
import MultiDeployment from "./Components/MultiDeployment/MultiDeployment";
import PriorityGroups from "./Components/PriorityGroups/PriorityGroups";
import State from "./Components/State/State";
import SCTK from "./Components/SCTK/SCTK";
import AwsSecretsManager from "./Components/AWS/AwsSecretsManager/AwsSecretsManager";
import AwsParameterStoreManager from "./Components/AWS/AwsParameterStoreManager/AwsParameterStoreManager";
import AwsCacheManager from "./Components/AWS/AwsCacheManager/AwsCacheManager";
import IacTfStateUnlock from "./Components/IaC/terraform/IacTfStateUnlock";
import Utils from "./Components/Utils/Utils";
import Crypto from "./Components/Utils/Crypto/Crypto";
import Git from "./Components/Utils/Git/Git";
import Keys from "./Components/Utils/Keys/Keys";
import RoleManagement from "./Components/RoleManagement/RoleManagement";
import UserManagement from "./Components/UserManagement/UserManagement";
import EditUser from "./Components/UserManagement/EditUser/EditUser";
import AttachTenants from "./Components/UserManagement/AttachTenants/AttachTenants";
import TenantManagement from "./Components/TenantManagement/TenantManagement";
import PrManagement from "./Components/PrManagement/PrManagement";
import GitHubMigration from "./Components/Utils/GitHubMigration/GitHubMigration";
import GitHubConfigurationMigration from "./Components/Utils/GitHubConfigurationMigration/GitHubConfigurationMigration";
// AI Components:
import AIMode from "./Components/AI/AIMode/AIMode";
import AIAugmentedSDLC from "./Components/AI/AIAugmentedSDLC/AIAugmentedSDLC";
import AIChatAgent from "./Components/AI/AIChatAgent/AIChatAgent";
import AISettings from "./Components/AI/AISettings/AISettings";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<PrivateRoute element={<Home />} />} />
          <Route
            path="/gitflow-release-management"
            element={<PrivateRoute element={<GitFlowReleaseManagement />} />}
          />
          <Route
            path="/gitflow-hotfix-management"
            element={<PrivateRoute element={<GitFlowHotfixManagement />} />}
          />
          <Route
            path="/tbd-release-management"
            element={<PrivateRoute element={<TBDReleaseManagement />} />}
          />
          <Route
            path="/multi-deployment"
            element={<PrivateRoute element={<MultiDeployment />} />}
          />
          <Route
            path="/priority-groups"
            element={<PrivateRoute element={<PriorityGroups />} />}
          />
          <Route
            path="/opened-release-hotfixes"
            element={<PrivateRoute element={<OpenedReleasesHotfixes />} />}
          />
          <Route path="/state" element={<PrivateRoute element={<State />} />} />
          <Route path="/sctk" element={<PrivateRoute element={<SCTK />} />} />
          <Route
            path="/aws-secrets-manager"
            element={<PrivateRoute element={<AwsSecretsManager />} />}
          />
          <Route
            path="/aws-parameter-store-manager"
            element={<PrivateRoute element={<AwsParameterStoreManager />} />}
          />
          <Route
            path="/aws-cache-manager"
            element={<PrivateRoute element={<AwsCacheManager />} />}
          />
          <Route
            path="/iac-tfstate-unlock"
            element={<PrivateRoute element={<IacTfStateUnlock />} />}
          />
          <Route path="/util" element={<PrivateRoute element={<Utils />} />} />
          <Route
            path="/util/crypto"
            element={<PrivateRoute element={<Crypto />} />}
          />
          <Route
            path="/util/keys"
            element={<PrivateRoute element={<Keys />} />}
          />
          <Route
            path="/util/git"
            element={<PrivateRoute element={<Git />} />}
          />
          <Route
            path="/user-management"
            element={<PrivateRoute element={<UserManagement />} />}
          />
          <Route
            path="/user-management/edit-user"
            element={<PrivateRoute element={<EditUser />} />}
          />
          <Route
            path="/user-management/attach-tenants"
            element={<PrivateRoute element={<AttachTenants />} />}
          />
          <Route
            path="/role-management"
            element={<PrivateRoute element={<RoleManagement />} />}
          />
          <Route
            path="/tenant-management"
            element={<PrivateRoute element={<TenantManagement />} />}
          />
          <Route
            path="/util/git/pr-management"
            element={<PrivateRoute element={<PrManagement />} />}
          />
          <Route
            path="/util/github-migration"
            element={<PrivateRoute element={<GitHubMigration />} />}
          />
          <Route
            path="/util/github-configuration-migration"
            element={<PrivateRoute element={<GitHubConfigurationMigration />} />}
          />
          <Route
            path="/ai-mode"
            element={<PrivateRoute element={<AIMode />} />}
          />
          <Route
            path="/ai-mode/ai-augmented-sdlc"
            element={<PrivateRoute element={<AIAugmentedSDLC />} />}
          />
          <Route
            path="/ai-mode/ai-chat-agent"
            element={<PrivateRoute element={<AIChatAgent />} />}
          />
          <Route
            path="/ai-mode/ai-settings"
            element={<PrivateRoute element={<AISettings />} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
